<template>
    <kgr-multi-select
        v-if="multiselect"
        :value="value"
        :options="options"
        :loading="loading"
        display="label"
        searchable
        @post-input="onInput"
    />
    <kgr-searchable-dropdown
        v-else
        :options="options"
        :initial-option="value"
        display="label"
        @post-input="onInput"
    />
</template>

<script>
import DogBreedRepository from '../../js/repository/DogBreedRepository.js';
import MultiSelect from '../common/form/select/MultiSelect.vue';
import SearchableDropdown from '../common/form/select/SearchableDropdown.vue'

export default {
    components: {
        'kgr-searchable-dropdown': SearchableDropdown,
        'kgr-multi-select': MultiSelect
    },
    props: {
        value: {
            type: [Object, Array],
            required: false,
            default: null
        },
        multiselect: {
            type: Boolean,
            required: false,
            default: false,
        },
        clubId: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            options: [],
            loading: false,
        }
    },
    mounted() {
        this.fetchOptions();
    },
    methods: {
        async fetchOptions() {
            this.loading = true;
            this.options = await DogBreedRepository.findAvailableBreeds(this.clubId);
            this.loading = false;
        },
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>

